import ConfigurationMultiselect from '../../../components/global/ConfigurationMultiselect/ConfigurationMultiselect';
import type { MultiselectCustomerPartialEntity } from '../../../components/global/ConfigurationMultiselect/configurationMultiselectTypes';
import React, { useCallback } from 'react';
import { updateScopeEntitySelectedIds } from './scopeConfigurationSlice';
import { ConfigurationRuleScopeEntityType } from '@ydistri/api-sdk';
import { useApplicationConfiguration } from '../../../hooks/useApplicationConfiguration';
import { useAppDispatch } from '../../../store';
import useMultiselectScopeTagRender from './useMultiselectScopeTagRender';

interface ScopeConfigurationMultiselectProps {
  selectedIds?: number[];
  entityType: ConfigurationRuleScopeEntityType;
  data: MultiselectCustomerPartialEntity[];
  dataCheck?: MultiselectCustomerPartialEntity[];
  dataCheckLabel?: string;
  loading?: boolean;
  tagWarnings?: Record<number, React.ReactNode | undefined>;
  missingIds?: number[];
}

const ScopeConfigurationMultiselect: React.FC<ScopeConfigurationMultiselectProps> = ({
  selectedIds = [],
  entityType,
  data,
  dataCheck,
  dataCheckLabel,
  loading,
  tagWarnings,
  missingIds,
}) => {
  const dispatch = useAppDispatch();
  const { mdbWarehouseIdAutoIncrement } = useApplicationConfiguration();
  const compareAsInt = mdbWarehouseIdAutoIncrement === 'INT';
  const tagRender = useMultiselectScopeTagRender({ entityType, tagWarnings, missingIds });

  const onChangeHandler = useCallback(
    (selectedIds: number[]) => {
      dispatch(updateScopeEntitySelectedIds({ entityType, selectedIds }));
    },
    [dispatch, entityType],
  );

  return (
    <ConfigurationMultiselect
      data={data}
      dataCheck={dataCheck}
      dataCheckLabel={dataCheckLabel}
      value={selectedIds}
      onValueChange={onChangeHandler}
      loading={loading}
      compareAsInt={compareAsInt}
      tagRender={tagRender}
    />
  );
};

export default ScopeConfigurationMultiselect;
